import './App.css';
import React, { useState, useEffect, useRef } from 'react';
import { BackIcon } from './Icons';
import { shuffle } from './utils';

export default function PassiveLearningApp({ words, onBack }) {
  const [shuffledWords] = useState(() => shuffle(words));
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [languageDirection, setLanguageDirection] = useState('pl-de');
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  const sourceLang = languageDirection === 'pl-de' ? 'pl' : 'de';
  const targetLang = languageDirection === 'pl-de' ? 'de' : 'pl';

  const goNext = () => { setCurrentIndex(prev => (prev + 1) % shuffledWords.length); setIsFlipped(false); };
  const goPrev = () => { setCurrentIndex(prev => (prev - 1 + shuffledWords.length) % shuffledWords.length); setIsFlipped(false); };

  const toggleLanguageDirection = () => {
    setLanguageDirection(prev => prev === 'pl-de' ? 'de-pl' : 'pl-de');
    setIsFlipped(false);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft')  goPrev();
      if (e.key === ' ') { e.preventDefault(); setIsFlipped(f => !f); }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shuffledWords.length]);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = e.changedTouches[0].clientY - touchStartY.current;
    touchStartX.current = null;
    touchStartY.current = null;

    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      e.preventDefault();
      if (dx < 0) goNext(); else goPrev();
    }
  };

  const currentWord = shuffledWords[currentIndex];

  return (
    <>
      <div className="flashcard-container passive-learning-container">
        <h1>Ucz się</h1>
        <div className="card-counter">{currentIndex + 1} / {shuffledWords.length}</div>

        <div className="language-toggle-container">
          <button onClick={toggleLanguageDirection} className="language-toggle-button">
            {languageDirection === 'pl-de' ? 'PL → DE' : 'DE → PL'}
          </button>
        </div>

        <div
          className={`card ${isFlipped ? 'is-flipped' : ''}`}
          onClick={() => setIsFlipped(f => !f)}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="card-face card-front">
            <span className="card-face-label">{sourceLang === 'pl' ? 'Polski' : 'Deutsch'}</span>
            {currentWord[sourceLang]}
          </div>
          <div className="card-face card-back">
            <span className="card-face-label">{targetLang === 'de' ? 'Deutsch' : 'Polski'}</span>
            {currentWord[targetLang]}
          </div>
        </div>

        <div className="swipe-hint">Dotknij aby odkryć · przesuń aby zmienić</div>

        <div className="card-navigation">
          <button className="btn-primary" onClick={goPrev}>← Poprzednie</button>
          <button className="btn-primary" onClick={goNext}>Następne →</button>
        </div>
      </div>
      <div className="floating-back-button"><button onClick={onBack}><BackIcon /></button></div>
    </>
  );
}
